import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';
import { useRouter } from 'next/router';

const useYoutubeCourses = (
  playlistId,
  options = { fallbackData: undefined }
) => {
  const router = useRouter();
  const isContentPage = router.asPath?.startsWith('/content/');
  const key = `api/youtube-playlist-courses/${playlistId}`;
  const { data: youtubePlaylistData, ...rest } = useFetch(
    isContentPage && playlistId ? key : null,
    { useCamelCase: true, hostType: HOST_TYPE.CMS },
    { fallbackData: options.fallbackData }
  );

  return {
    key,
    youtubePlaylistData,
    ...rest
  };
};

export default useYoutubeCourses;
